import React, { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Snackbar from "@mui/material/Snackbar";
import { blue } from "@mui/material/colors";
import CircleIcon from "@mui/icons-material/Circle";
import Grid from "@mui/material/Grid";


export function SimpleNotesPopup(props) {
  const { onClose, selectedValue, openNotePoints, noteData = null } = props;

  const [copyMessage, setCopyMessage] = useState("");

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopyMessage("Copied to clipboard");
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? "N/A" : parsed.toLocaleDateString("en-GB");
  };

  return (
    <>
      <Dialog
        onClose={handleClose}
        open={openNotePoints}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Notes</DialogTitle>
        
        <List sx={{ pt: 0, px: 2 }}>
          <Grid container spacing={2}>
            {Array.isArray(noteData) &&
              noteData.map(({ label, value }, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <ListItem
                    disablePadding
                    sx={{ minWidth: 0 }}
                  >
                    <ListItemButton
                      onClick={() => handleCopy(String(value))}
                    >
                      <ListItemAvatar sx={{ minWidth: "30px" }}>
                        <CircleIcon sx={{ fontSize: "8px", color: blue[600] }} />
                      </ListItemAvatar>

                      <ListItemText
                        primary={
                          <>
                            <strong
                              style={{
                                display: "block",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                              }}
                            >
                              {label}
                            </strong>
                            <span>{value || "N/A"}</span>
                          </>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </Grid>
              ))}
          </Grid>
        </List>
      </Dialog>

      <Snackbar
        open={!!copyMessage}
        autoHideDuration={1500}
        message={copyMessage}
        onClose={() => setCopyMessage("")}
      />
    </>
  );
}
